import {
  brandEntityId,
  BrandEntityId,
  brandLogoDataFile,
  BrandLogoDataFile,
  brandLogoDataHeight,
  BrandLogoDataHeight,
  brandLogoDataWidth,
  BrandLogoDataWidth,
  RoomId,
  roomId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandLogoCreateRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandLogoCreateRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomBrandLogoCreateRequest) {
    JsonSchemaValidator.assert(RoomBrandLogoCreateRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandId", "data", "width", "height"],
      properties: {
        roomId,
        brandId: brandEntityId,
        data: brandLogoDataFile,
        width: brandLogoDataWidth,
        height: brandLogoDataHeight
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandLogoCreateRequest {
  roomId: RoomId;
  brandId: BrandEntityId;
  data: BrandLogoDataFile;
  width: BrandLogoDataWidth;
  height: BrandLogoDataHeight;
}
